import { Controller } from "@hotwired/stimulus";

const AUTO_CLOSE_MS = 8000;

export default class extends Controller {
  static targets = ["message"];

  connect() {
    this.timeouts = [];

    [...this.messageTargets].reverse().forEach((item, index) => {
      const timeout = setTimeout(() => {
        item.querySelector(".btn-close")?.click();
      }, AUTO_CLOSE_MS * (index + 1));
      this.timeouts.push(timeout);
    });
  }

  disconnect() {
    this.timeouts?.forEach((timeout) => clearTimeout(timeout));
  }
}
